import React, { useEffect, useState } from 'react';
import {
  Box, Divider, IconButton, TextField, Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import useStyles from '../styles';
import CustomButton from '../../../components/General/CustomButton';
import useFetchApi from '../../../hooks/useFetchApi';
import { GetSpeciesResponse } from '../../../requests/api/apiTypes';

const UpsertModalSpeciesContent = ({
  handleCloseModal,
  handleUpsertFunction,
  id,
  isLoadingUpsert,
}: {
  handleCloseModal: VoidFunction,
  handleUpsertFunction: ({ name, id }: { name: string, id?: string }) => void,
  id?: string,
  isLoadingUpsert: boolean,
}) => {
  const classes = useStyles();
  const [name, setName] = useState('');
  const [beenUpdated, setBeenUpdated] = useState(false);
  const [error, setError] = useState({ message: '', active: false });

  const entityToModify = id && useFetchApi<GetSpeciesResponse>({
    modelName: 'species',
    modelEndpoint: 'speciesList',
  });

  useEffect(() => {
    if (id && entityToModify && entityToModify.data && !beenUpdated) {
      const found = entityToModify.data.species?.find((s) => s.id === id);
      setName(found?.name ?? '');
      setBeenUpdated(true);
    }
  }, [entityToModify]);

  const handleSubmit = () => {
    if (name.trim() === '') {
      setError({ message: 'El nombre no puede estar vacío', active: true });
      return;
    }
    handleUpsertFunction({ name: name.trim(), id });
  };

  return (
    <Box className={classes.upsertVarietyModalContainer}>
      <Box className={classes.upsertVarietyModalHeader}>
        <Typography
          variant="h3"
          color="textPrimary"
          className={classes.upsertVarietyModalHeaderTitle}
        >
          <span className={classes.activePageUnderlined}>
            {id ? 'Editar especie' : 'Agregar especie'}
          </span>
        </Typography>
        <IconButton onClick={handleCloseModal}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider className={classes.dividerStyle} />
      <Box mt={2} mb={2}>
        <TextField
          variant='standard'
          label='Nombre'
          fullWidth
          required
          error={error.active}
          helperText={error.active ? error.message : ''}
          value={name}
          onChange={(e) => {
            setError({ message: '', active: false });
            setName(e.target.value);
          }}
        />
      </Box>
      <Box className={classes.upsertVarietyModalButtonsContainer}>
        <Box width='100%' mr={2}>
          <CustomButton color='blue' buttonText='Cancelar' onClick={handleCloseModal} />
        </Box>
        <Box width='100%' ml={2}>
          <CustomButton
            color='green'
            buttonText={id ? 'Editar' : 'Agregar'}
            onClick={handleSubmit}
            disabled={isLoadingUpsert}
            setLoadingSpinnerWhenDisabled={true}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default UpsertModalSpeciesContent;
